module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-800"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型名称",
      "prop": "cost_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.cost_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.cost_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b049cd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/cost/add.vue
// module id = 1865
// module chunks = 2